<template>
  <div class="documents-wrapper">
    <hilo-button
      styleType="grey"
      style="margin-right: 20px"
      label="Documents"
      @click="toggleDocumentsView"
    />
    <div v-if="!isLoading && toggleDocuments" class="documents-section">
      <div v-if="documents.length === 0" class="no-documents-message">
        No Documents Found
      </div>
      <div
        v-else
        v-for="(document, index) in documents"
        :key="index"
        class="document-item"
      >
        <span class="document-icon" @click="openDocument(document)">
          <i class="fas fa-file-alt"></i>
        </span>
        <span class="document-label">{{ document.label }}</span>
      </div>
    </div>

    <HiloModal
      v-if="showModal"
      :isVisible="showModal"
      :title="selectedDocument.label"
      imageViewer
      @close="closeModal"
    >
      <object
        v-if="selectedDocument.label === 'Signed Contract'"
        :data="selectedDocument.url"
        type="application/pdf"
        width="800px"
        height="800px"
        style="margin-bottom: 20px"
      >
        Your browser does not support viewing PDFs. Please download the PDF to
        view it:
        <a :href="selectedDocument.url" download>Download Quote</a>
      </object>
      <img
        v-else
        :src="selectedDocument.url"
        :alt="selectedDocument.label"
        style="
          width: 800px;
          height: 800px;
          object-fit: cover;
          margin-bottom: 20px;
        "
      />
    </HiloModal>
  </div>
</template>

<script>
import HiloButton from "@/components/HiloComponents/HiloButton.vue";
import HiloModal from "@/components/HiloComponents/HiloModal.vue";
import ActiveStudentsAPIService from "src/servicehandlers/ActiveStudentsAPIService.js";
import ActiveInstructorsAPIService from "src/servicehandlers/ActiveInstructorsAPIService";
const activeStudentsAPIService = new ActiveStudentsAPIService();
const activeInstructorsAPIService = new ActiveInstructorsAPIService();

export default {
  components: { HiloModal, HiloButton },
  props: {
    userId: {
      type: Number,
      required: true,
    },
    userType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      toggleDocuments: false,
      documents: [],
      showModal: false,
      selectedDocument: null,
      isLoading: false,
    };
  },
  methods: {
    toggleDocumentsView() {
      this.toggleDocuments = !this.toggleDocuments;
      if (this.toggleDocuments) {
        this.fetchDocuments();
      }
    },
    async fetchDocuments() {
      this.isLoading = true;
      try {
        let response;
        if (this.userType === "Student") {
          response = await activeStudentsAPIService.getDocumentsByUserId(
            this.userId,
          );
        } else if (this.userType === "Instructor") {
          response = await activeInstructorsAPIService.getDocumentsByUserId(
            this.userId,
          );
        }

        const baseUrl = process.env.VUE_APP_API_URL;
        const formatUrl = (path) =>
          `${baseUrl}/file_uploads/${path.split("/").pop()}`;

        this.documents = [
          {
            label: "Photo ID",
            url: response.photoId ? formatUrl(response.photoId) : null,
          },
          {
            label: "Medical Certificate",
            url: response.medicalCert ? formatUrl(response.medicalCert) : null,
          },
          {
            label: "TSA Certification",
            url: response.birthCert ? formatUrl(response.birthCert) : null,
          },
          {
            label: "Commercial Certification",
            url: response.commercialCert ? formatUrl(response.commercialCert) : null,
          },
          {
            label: "CFI Certification",
            url: response.cfiCert ? formatUrl(response.cfiCert) : null,
          },
          {
            label: "Signed Contract",
            url: response.quoteImage ? formatUrl(response.quoteImage) : null,
          },
        ].filter((doc) => doc.url);

        this.isLoading = false;
      } catch (error) {}
    },
    openDocument(document) {
      this.selectedDocument = document;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.selectedDocument = null;
    },
  },
};
</script>

<style scoped>
.documents-wrapper {
  display: inline-block;
}

.documents-section {
  position: absolute;
  margin-top: 5px;
  padding: 15px;
  background-color: #d9d9d9;
  border-radius: 8px;
  z-index: 100;
}

.document-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.document-icon {
  font-size: 18px;
  color: #333;
  cursor: pointer;
  margin-right: 10px;
}

.document-label {
  font-size: 16px;
  color: #333;
}
</style>
